import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "@/utils/debounce";
/**
 * Search Input Filter Component
 * Designed to work with the new filter architecture
 * Simple text input for search functionality with debounce
 */
const SearchFilter = ({ name, value = "", onChange, label, placeholder = "Поиск...", allowClear = true, style, showSearchIcon = true, debounceDelay = 300, }) => {
    const [localValue, setLocalValue] = useState(value);
    // Обновляем локальное значение при изменении внешнего value
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    // Создаем debounced версию onChange
    const debouncedOnChange = useCallback(debounce((val) => {
        onChange(val);
    }, debounceDelay), [onChange, debounceDelay]);
    const handleChange = (e) => {
        const newValue = e.target.value;
        setLocalValue(newValue); // Немедленно обновляем UI
        debouncedOnChange(newValue); // Debounced вызов onChange
    };
    return (_jsxs("div", { children: [label && (_jsxs("label", { style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#595959",
                    marginBottom: "4px",
                    display: "block",
                }, children: [label, ":"] })), _jsx(Input, { placeholder: placeholder, style: { width: "100%", ...style }, value: localValue, allowClear: allowClear, onChange: handleChange, prefix: showSearchIcon ? _jsx(SearchOutlined, {}) : undefined, "data-filter-name": name, "data-filter-type": "input" })] }));
};
export default SearchFilter;
